import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Alert, Dropdown, Tabs } from 'tdesign-react';
import { TypeAnimation } from 'react-type-animation';
import {
  removeTab,
  selectTab,
  copyTab,
  removeRight,
  removeOtherTabs,
  removeAllTabs,
} from '@/slices/resourceSlice';
import Terminal from './Terminal';

const { TabPanel } = Tabs;

const options = [
  {
    value: 'copy',
    content: '复制窗口',
  },
  {
    value: 'reconnect',
    content: '重新连接',
  },
  {
    value: 'rClose',
    content: '关闭右侧',
  },
  {
    value: 'oClose',
    content: '关闭其他',
  },
  {
    value: 'aClose',
    content: '关闭所有',
  },
];

function Right({
  tabs,
  currentTab,
  selectTab,
  removeTab,
  copyTab,
  removeRight,
  removeOtherTabs,
  removeAllTabs,
}) {
  const [refreshTabId, setRefreshTabId] = useState();

  const onRemove = ({ value }) => {
    removeTab(value);
  };

  const dropDownClick = (value, tabId) => {
    switch (value) {
      case 'copy':
        copyTab(currentTab);
        break;
      case 'rClose':
        removeRight(tabId);
        break;
      case 'oClose':
        removeOtherTabs(tabId);
        break;
      case 'aClose':
        removeAllTabs();
        break;
      case 'reconnect': // 简单强制刷新tabId
        setRefreshTabId(tabId);
        setTimeout(() => setRefreshTabId(null), 20);
        break;
      default:
        break;
    }
  };

  return isEmpty(tabs) ? (
    <Root>
      <Alert message='双击标签快速复制窗口，右击标签展开更多操作。' />
      <Container>
        <div>
          {logo.split('\n').map((item, index) => (
            <TypeAnimation
              key={index}
              style={{ margin: 0 }}
              cursor={false}
              wrapper='pre'
              sequence={[item]}
              speed={96}
            />
          ))}
        </div>
      </Container>
    </Root>
  ) : (
    <Root>
      <Tabs value={currentTab?.tabId} onChange={selectTab} onRemove={onRemove}>
        {tabs.map((tab) => (
          <TabPanel
            destroyOnHide={false}
            removable
            label={
              <Dropdown
                trigger='context-menu'
                options={options}
                onClick={({ value }) => dropDownClick(value, tab.tabId)}
              >
                <span onDoubleClick={() => copyTab(currentTab)}>{tab.serviceIp || tab.hostIp}</span>
              </Dropdown>
            }
            value={tab.tabId}
            key={tab.tabId}
          >
            {tab.tabId !== refreshTabId && <Terminal detail={tab} />}
          </TabPanel>
        ))}
      </Tabs>
    </Root>
  );
}

export default connect(
  (state) => ({
    tabs: state.resource.tabs,
    currentTab: state.resource.currentTab,
  }),
  {
    selectTab,
    removeTab,
    copyTab,
    removeRight,
    removeOtherTabs,
    removeAllTabs,
  },
)(Right);

const Root = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  border-left: 2px solid #edeff2;
  padding: 16px 16px 0;
`;

const Container = styled.div`
  flex: 1;
  padding: 24px;
  border-radius: 8px;
  background: #2b2b2b;
  color: #edeff2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 12px 0 12px 0;
  font-size: 12px;
`;

const logo = String.raw`
         _                 _            _             _            _          _       
        / /\              / /\        /\ \           /\ \         /\ \     _ /\ \     
       / /  \            / /  \      /  \ \         /  \ \       /  \ \   /\_\_\ \    
      / / /\ \          / / /\ \__  / /\ \ \       / /\ \ \     / /\ \ \_/ / /\__ \   
     / / /\ \ \        / / /\ \___\/ / /\ \ \     / / /\ \_\   / / /\ \___/ / /_ \ \  
    / / /  \ \ \       \ \ \ \/___/ / /  \ \_\   / /_/_ \/_/  / / /  \/____/ / /\ \ \ 
   / / /___/ /\ \       \ \ \    / / /    \/_/  / /____/\    / / /    / / / / /  \/_/ 
  / / /_____/ /\ \  _    \ \ \  / / /          / /\____\/   / / /    / / / / /        
 / /_________/\ \ \/_/\__/ / / / / /________  / / /______  / / /    / / / / /         
/ / /_       __\ \_\ \/___/ / / / /_________\/ / /_______\/ / /    / / /_/ /          
\_\___\     /____/_/\_____\/  \/____________/\/__________/\/_/     \/_/\_\/           
        _         _           _           _            _                 _   _        
       / /\      /\ \        /\ \        /\ \         / /\              /\_\/\_\ _    
      / /  \     \_\ \      /  \ \      /  \ \       / /  \            / / / / //\_\  
     / / /\ \__  /\__ \    / /\ \ \    / /\ \ \     / / /\ \          /\ \/ \ \/ / /  
    / / /\ \___\/ /_ \ \  / / /\ \_\  / / /\ \_\   / / /\ \ \        /  \____\__/ /   
    \ \ \ \/___/ / /\ \ \/ / /_/ / / / /_/_ \/_/  / / /  \ \ \      / /\/________/    
     \ \ \    / / /  \/_/ / /__\/ / / /____/\    / / /___/ /\ \    / / /\/_// / /     
 _    \ \ \  / / /     / / /_____/ / /\____\/   / / /_____/ /\ \  / / /    / / /      
/_/\__/ / / / / /     / / /\ \ \  / / /______  / /_________/\ \ \/ / /    / / /       
\ \/___/ / /_/ /     / / /  \ \ \/ / /_______\/ / /_       __\ \_\/_/    / / /        
 \_____\/  \_\/      \/_/    \_\/\/__________/\_\___\     /____/_/       \/_/         
                                                                                      
`;
